import { css, cx } from '@emotion/css';
import { Select, SelectProps } from 'antd';
import { useEffect, useMemo } from 'react';
import { phoneCodeRegionsMap } from 'utils/phoneHelpers';
import { isQuickChat } from 'productLine';
import mobileSvg from '../assets/mobile.svg';
import usePhoneCountry from '../usePhoneCountry';
import { useCountryCodeValue } from 'hooks/business/system/useCountryCode';
import { useLatest } from 'ahooks';

const QuickChatSelect = css`
  position: relative;
  width: 104px !important;
  .ant-select-selector {
    padding-left: ${isQuickChat ? '30px !important' : ''};
    .ant-select-selection-search {
      left: ${isQuickChat ? '30px !important' : '11px'};
    }
  }

  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 24px !important;
    height: 24px;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url(${`"${mobileSvg}"`});
    background-repeat: no-repeat;
    background-position: 4px center;
    z-index: 2;
  }
`;
export interface PhoneRegionSelectProps
  extends Omit<SelectProps, 'onChange' | 'options' | 'value'> {
  value?: General.PhoneRegionCodes;
  onChange?: (value: General.PhoneRegionCodes, region: General.PhoneRegions) => void;
}
const PhoneRegionSelect = (props: PhoneRegionSelectProps) => {
  const { value, onChange, className, ...selectProps } = props;
  const pcArr = usePhoneCountry();
  const countryCode = useCountryCodeValue();
  const onChangeRef = useLatest(onChange);
  const pcArrRef = useLatest(pcArr);
  useEffect(() => {
    const find = pcArrRef.current?.find((pc) => pc.k === countryCode?.toLocaleLowerCase());
    if (find) {
      onChangeRef.current?.(find.ma, phoneCodeRegionsMap[find.ma]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  return (
    <Select<General.PhoneRegionCodes>
      className={isQuickChat ? cx(className, QuickChatSelect) : className}
      showSearch
      value={value}
      onChange={(value) => {
        onChange && onChange(value, phoneCodeRegionsMap[value]);
      }}
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ width: '280px' }}
      optionLabelProp="code"
      optionFilterProp="label"
      options={useMemo(
        () =>
          pcArr.map((pc) => {
            return {
              label: `${pc.ma} ${pc.n}`,
              value: pc.ma,
              name: `${pc.ma}`,
              code: pc.ma,
            };
          }),
        [pcArr],
      )}
      {...selectProps}
    />
  );
};
export default PhoneRegionSelect;
